import _ from 'lodash';
import {
  RECEIVE_IFP_APPS,
  UPDATE_IFP_APP,
  REPLACE_IFP_APPS,
} from '../actions/ifpApps';

import {
  DELETE_MEMBER,
} from '../actions/members';

export default function ifpApps(state = [], action) {
  switch (action.type) {
    case RECEIVE_IFP_APPS: {
      const newApps = action.ifpApps;
      // don't change the state if there aren't any apps to add
      if (!Array.isArray(newApps) || !newApps.length) {
        return state;
      }

      // newApps should precede state so they are preferred in the uniq check
      return _.uniqBy(newApps.concat(state), 'app_id');
    }
    case UPDATE_IFP_APP: {
      const appIndex = _.findIndex(state, { app_id: action.appId });
      if (appIndex === -1) {
        return state;
      }

      const { app_id, ...data } = action.data;
      const newApp = {
        ...state[appIndex],
        ...data,
      };

      const newState = state.slice(0);
      newState.splice(appIndex, 1, newApp);
      return newState;
    }
    case REPLACE_IFP_APPS:
      return action.ifpApps;
    case DELETE_MEMBER:
      return state.map(app => (
        _.find(app.members, { id: action.data.id })
          ? { ...app, members: _.reject(app.members, { id: action.data.id }) }
          : app
      ));
    default:
      return state;
  }
}
